module.exports = __webpack_public_path__ + "static/media/market-analysis.7934c8d9.svg";